export default function PanneBubendorff() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-4xl mx-auto px-4 md:px-8">
        <h2 className="text-2xl md:text-3xl font-bold text-brand-blue mb-6">
          Panne de moteur Bubendorff : symptômes et causes
        </h2>
        <p className="text-brand-text leading-relaxed mb-5">
          Bubendorff est un fabricant alsacien de volets roulants qui a bâti sa réputation sur des tabliers à moteur intégré. Contrairement aux volets classiques où le moteur tubulaire se glisse dans l&apos;axe, les systèmes Bubendorff embarquent le moteur directement dans le tablier, ce qui change radicalement la méthode de diagnostic et de remplacement. Lorsque votre volet Bubendorff reste bloqué, descend par à-coups ou ne répond plus à la télécommande, il s&apos;agit souvent d&apos;une défaillance du moteur intégré ou de son électronique de commande.
        </p>
        <p className="text-brand-text leading-relaxed mb-8">
          La spécificité la plus marquante des volets Bubendorff réside dans leur commande radio propriétaire et, pour certains modèles, leur alimentation par batteries solaires. La télécommande communique avec le moteur via un protocole radio spécifique, ce qui implique qu&apos;un remplacement doit impérativement inclure la reprogrammation des émetteurs. Les modèles solaires, quant à eux, ne nécessitent aucun raccordement électrique mural, mais dépendent de batteries rechargeables par panneaux photovoltaïques. Si la batterie atteint sa fin de vie, le volet devient inopérant même si le moteur est encore fonctionnel. Nos techniciens sont formés à identifier ces particularités : ils vérifient d&apos;abord l&apos;état des batteries solaires, testent la réception radio et mesurent la tension du moteur avant de décider d&apos;un remplacement complet.
        </p>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Signes courants d&apos;une panne de moteur Bubendorff
        </h3>
        <ul className="space-y-3 mb-8">
          {[
            "Le volet ne répond plus à aucune télécommande ou interrupteur",
            "Le tablier descend mais ne remonte pas, ou inversement",
            "Mouvements saccadés ou bruit de blocage mécanique lors de la manœuvre",
            "Télécommande Bubendorff dont le voyant clignote sans actionner le volet",
            "Batterie solaire pleine mais le moteur ne démarre pas",
            "Odeur de brûlé ou surchauffe apparente du coffre de volet",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>

        <h3 className="text-xl font-semibold text-brand-blue mb-4">
          Causes principales du dysfonctionnement
        </h3>
        <ul className="space-y-3">
          {[
            "Usure naturelle du moteur intégré après 10 à 15 ans de service",
            "Défaillance de l&apos;électronique embarquée ou du récepteur radio",
            "Batterie solaire hors d&apos;usage ou panneau photovoltaïque dégradé",
            "Mauvais réglage des fins de course provoquant un surmenage",
            "Obstacle dans le tablier ou glissière déformée forçant sur le moteur",
            "Condensateur ou platine de commande endommagée par une surtension",
          ].map((item) => (
            <li key={item} className="flex items-start gap-3">
              <span className="w-5 h-5 flex items-center justify-center text-brand-cyan mt-0.5 flex-shrink-0">
                <i className="ri-checkbox-circle-line text-lg"></i>
              </span>
              <span className="text-brand-text text-sm md:text-base">{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}